export const cssBundleHref = "/build/css-bundle-J2ZHSOTF.css";